import React from "react";
import { Link as LinkScroll, Element } from "react-scroll";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import FeatureCards from "../components/FeatureCards";
import InfoSection from "../components/InfoSection";
import styles from "../LandingPage.module.scss";

import { icon1, icon2, icon3, icon4, note1, note2, note3, note4, globogabipng, globogabipngv2 } from "./index";

const cards = [
    {
        icon: icon1,
        titulo: "Tudo Integrado",
        texto: "Tenha um canal próprio e com todos os recursos integrados para gerenciar as tarefas, atividades e resultados."
    },
    {
        icon: icon2,
        titulo: "Do seu jeito",
        texto: "Personalize seu canal de aprendizagem como achar melhor, mantendo seus estudantes e atraindo novos alunos."
    },
    {
        icon: icon3,
        titulo: "Conecte-se em qualquer lugar",
        texto: "Amplifique o alcance do seu centro de ensino com novas possibilidades de aprendizagem."
    },
    {
        icon: icon4,
        titulo: "Atendimento e suporte humanizado",
        texto: "Ouvimos você e designamos agentes especializados em educação e tecnologia, encontrando a melhor solução para o seu negócio dentro da Stepforma."
    }
];

const LandingPage = () => {
    const whatsapp = "https://api.whatsapp.com/send?phone=+55 1199609-1683s&text=Eu tenho interesse em aderir &agrave; Stepforma";

    return (
        <div className={styles.homeContainer}>
            <div className={styles.homeHero}>
                <div className={styles.heroInfoBlock}>
                    <h1 className={styles.heroTitle}>Inicie seu Ambiente de Aprendizagem.</h1>
                    <p className={styles.heroText}>
                        Crie um ambiente de aprendizagem e treinamentos completo para a sua instituição, contando com as ferramentas e o
                        controle que você precisa. Em alguns cliques, tenha todas as ferramentas para engajar seus usários nas atividades
                        que designar e avaliar o progresso de todos.
                    </p>
                    <p className={styles.heroText}>
                        Tecnologia e gestão simplificada unidas em um só lugar, garantindo mais tranquilidade e resultados para sua
                        instituição!
                    </p>
                    <div className={styles.heroButtons}>
                        <a href={whatsapp} target="_blank" className={styles.btnPrimary}>
                            Iniciar
                        </a>
                        <LinkScroll to="stepforma" className={styles.btnSecondary} smooth={true} offset={-100} duration={500}>
                            Saiba Mais
                        </LinkScroll>
                    </div>
                </div>
                <div className={`${styles.heroImg} ${styles.heroImgDesktop}`}>
                    <LazyLoadImage alt="Foto" effect="opacity" src={globogabipng} className="lazy-image" />
                </div>
                <div className={`${styles.heroImg} ${styles.heroImgTablet}`}>
                    <LazyLoadImage alt="Foto" effect="opacity" src={globogabipngv2} className="lazy-image" />
                </div>
            </div>
            <div className={styles.line}></div>
            <InfoSection titulo="Conteúdos" imagem={note1} className={styles.homeBlock1}>
                <span className={styles.infoBlockTitle}>Cursos</span>
                <span>Organizados por categorias, anos e turmas</span>
                <span>Planos de ensino com diversos cursos e disciplinas</span>
                <span className={styles.infoBlockTitle} style={{ marginTop: 20 }}>
                    Atividades, Tarefas e Documentação
                </span>
                <span>Trilhas de cursos e de atividades</span>
                <span>Cursos estruturados por atividades e tarefas</span>
                <span>Drive / repositório de documentação, privada ou partilhada</span>
                <span>Diversos tipos de tarefas (vídeos, pdf, avaliações, questionários, trabalhos, etc..)</span>
            </InfoSection>
            <FeatureCards cards={cards} className={styles.homeBlock2} />
            <Element name="stepforma">
                <InfoSection titulo="Afinal, o que é a Stepforma?" imagem={note2} className={styles.homeBlock3}>
                    <span>
                        A Stepforma é uma plataforma que reúne diversas ferramentas funções administrativas e pedagógicas em um só lugar.
                        Pensada para gestão do processo ensino-aprendizagem, a sua instituição pode ter um ambiente virtual de aprendizagem
                        completamente integrado com ferramentas como:
                    </span>
                    <ul>
                        <li>Gestão de usuários</li>
                        <li>Diário eletrônico</li>
                        <li>Estatísticas</li>
                        <li>Resultados</li>
                    </ul>
                    <span>A Stepforma é a sua porta de entrada para os benefícios da educação tecnológica e integrada.</span>
                </InfoSection>
            </Element>
            <InfoSection titulo="Transforme a experiência do ensino" imagem={note3} imagemEsquerda className={styles.homeBlock4}>
                <span className={styles.infoBlockTitle}>Flexibilidade e eficácia</span>
                <span>
                    Complementando as atividades síncronas, a Stepforma oferece total flexibilidade para criação, edição e acompanhamento de
                    cursos e atividades assíncronas.
                </span>
                <span className={styles.infoBlockTitle} style={{ marginTop: 20 }}>
                    Versatilidade
                </span>
                <span>Crie e acesse conteúdos em diversos formatos, com traduções automatizadas de linguagens.</span>
                <span className={styles.infoBlockTitle} style={{ marginTop: 20 }}>
                    Use onde quiser
                </span>
                <span>
                    Com seu uso responsivo, a Stepforma se adapta a qualquer que seja o dispositivo utilizado, em todas as instâncias de
                    usuários.
                </span>
            </InfoSection>
            <InfoSection titulo="Tudo do seu jeito" imagem={note4} imagemEsquerda className={styles.homeBlock5}>
                <span className={styles.infoBlockTitle}>Totalmente personalizável</span>
                <span>
                    Entregamos um AVA (Ambiente Virtual de Aprendizagem) 100% adequado as suas necessidades, criado a partir das suas
                    requisições.
                </span>
                <span className={styles.infoBlockTitle} style={{ marginTop: 20 }}>
                    Centralidade no aluno
                </span>
                <span>
                    Crie cursos e atividades próprias, direcionando-as a turmas e alunos específicos para criar trilhas de aprendizagem
                    únicas e assertivas, unido a recursos{" "}
                </span>
                <span className={styles.infoBlockTitle} style={{ marginTop: 20 }}>
                    Suporte
                </span>
                <span>
                    Encontre na Stepforma o suporte humanizado e dedicado a fazer seu centro de ensino funcionar de maneira digital e
                    escalável.
                </span>
            </InfoSection>
        </div>
    );
};

export default LandingPage;
